import { render } from "./cdrBatchList.vue?vue&type=template&id=e3bd8c5e&scoped=true"
import script from "./cdrBatchList.vue?vue&type=script&lang=js"
export * from "./cdrBatchList.vue?vue&type=script&lang=js"

import "./cdrBatchList.vue?vue&type=style&index=0&id=e3bd8c5e&scoped=true&lang=css"
import "./cdrBatchList.vue?vue&type=style&index=1&id=e3bd8c5e&lang=css"
script.render = render
script.__scopeId = "data-v-e3bd8c5e"

export default script